import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Form,
  Jumbotron,
  Row,
  Col,
  Button,
  Spinner,
  Alert,
} from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import { openNewTicket } from "./addTicketAction";
import { shortText } from "../../utils/validation";
import { restSuccessMSg } from "./addTicketSlicer";
import { ToastContainer, toast } from "react-toastify";


import "./add-ticket-form.style.css";

const initialFrmError = {
  customerName: false,
  serialNumber: false,
  epromSerialNumber: false,
};

export const AddTicketForm = () => {
  const dispatch = useDispatch();
  //const history = useHistory();

  const { user } = useSelector((state) => state.user);

  const username = user.name;
 
  const { isLoading, error, successMsg } = useSelector(
    (state) => state.openTicket
  );

  const [customerName, setCustomerName] = useState(user.name);
    const [description, setDescription] = useState('');

   const initialFrmDt = {
     customerName: "",
     companyName:"",
     serialNumber: "",
     epromSerialNumber: "",
     message: "",
     battery: false,
     eprom: false,
     transmitter: false,
     receiver: false,
     description:"",
   };
  const [frmData, setFrmData] = useState(initialFrmDt);
  const [battery, setBattery] = useState(true);
  const [eprom, setEprom] = useState(true);
  const [transmitter, setTransmitter] = useState(true);
  const [receiver, setReceiver] = useState(true);
  const [frmDataErro, setFrmDataErro] = useState(initialFrmError);
  const [addTicketSuccess, setAddTicketSuccess] = useState(false);

  toast.configure();
  function toastLogin() {
    toast.success("New ticket has been created", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  }

  useEffect(() => {
   // setCustomerName(user.name);
    //console.log(username);
    return () => {
      successMsg && dispatch(restSuccessMSg());
    };
  }, [dispatch, frmData, frmDataErro]);


  useEffect(() => {
    if (addTicketSuccess == true) 
    {
      toastLogin();
      }
  }, [addTicketSuccess]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;

if (name === 'customerName') {
  setFrmData({
    ...frmData,
    [name]: value,
  });
  setCustomerName(value);
}  
if (name === "description") {
  setFrmData({
    ...frmData,
    [name]: value,
  });
  setDescription(value);
}      
if (name === 'battery') {
  setFrmData({
    ...frmData,
    [name]: battery,
  });
  setBattery(!battery);
}      
else if(name === 'eprom') {
  setFrmData({
    ...frmData,
    [name]: eprom,
  });
  setEprom(!eprom)
}
else if (name === 'transmitter') {
  setFrmData({
    ...frmData,
    [name]: transmitter,
  });
  setTransmitter(!transmitter)
}
else if (name === 'receiver') {
  setFrmData({
    ...frmData,
    [name]: receiver,
  });
  setReceiver(!receiver)
}else{
  setFrmData({
    ...frmData,
    [name]: value,
  });
}
    //console.log(frmData);
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();

    //setFrmDataErro(initialFrmError);

    //const isSubjectValid = await shortText(frmData.subject);

    //setFrmDataErro({
    //  ...initialFrmError,
      //subject: !isSubjectValid,
    // });

    dispatch(
      openNewTicket({ ...frmData, sender: user.name })
    ).then((result) => {

      if (result.status === "success") {
        setAddTicketSuccess(true);
      }
    });;
    toastLogin();
    //history.push("/tickets");
  };

 

  return (
    <Jumbotron className="mt-3 add-new-ticket bg-light">
      <h1 className="text-dark text-center">Add New Ticket</h1>
      <hr />
      <div>
        {error && <Alert variant="danger">{error}</Alert>}
        {successMsg && <Alert variant="dark">{successMsg}</Alert>}
        {isLoading && <Spinner variant="dark" animation="border" />}
      </div>
      <Form autoComplete="off" onSubmit={handleOnSubmit}>
        <Form.Group as={Row}>
          <Form.Label column sm={3}>
            Customer Name
          </Form.Label>
          <Col sm={9}>
            <Form.Control
              name="customerName"
              value={frmData.customerName}
              // maxLength="100"
              onChange={handleOnChange}
              placeholder={"Customer Name"}
              required
              defaultValue={user.name}
            />
            <Form.Text className="text-danger">
              {frmDataErro.customerName && "Customer Name is Required!"}
            </Form.Text>
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column sm={3}>
            End User
          </Form.Label>
          <Col sm={9}>
            <Form.Control
              name="companyName"
              value={frmData.companyName}
              // maxLength="100"
              onChange={handleOnChange}
              placeholder={"End User"}
              required
              //defaultValue={user.name}
            />
            <Form.Text className="text-danger">
              {frmDataErro.companyName && "End User is Required!"}
            </Form.Text>
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column sm={3}>
            Serial Number
          </Form.Label>
          <Col sm={9}>
            <Form.Control
              name="serialNumber"
              value={frmData.serialNumber}
              // maxLength="100"
              onChange={handleOnChange}
              placeholder="Serial Number"
              required
            />
            <Form.Text className="text-danger">
              {frmDataErro.serialNumber && "Serial Number is Required!"}
            </Form.Text>
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column sm={3}>
            Eprom Serial Number
          </Form.Label>
          <Col sm={9}>
            <Form.Control
              name="epromSerialNumber"
              value={frmData.epromSerialNumber}
              // maxLength="100"
              onChange={handleOnChange}
              placeholder="Eprom Serial Number"
              required
            />
            <Form.Text className="text-danger">
              {frmDataErro.epromSerialNumber &&
                "Eprom Serial Number is Required!"}
            </Form.Text>
          </Col>
        </Form.Group>
   
        <Form.Group as={Row}>
          <Col>
            <Form.Check
              type="checkbox"
              id="check 1"
              name="transmitter"
              onChange={handleOnChange}
              label="Transmitter"
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Col>
            <Form.Check
              type="checkbox"
              id="check 2"
              name="receiver"
              onChange={handleOnChange}
              label="Receiver"
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Col>
            <Form.Check
              type="switch"
              name="battery"
              id="switch 1"
              onChange={handleOnChange}
              label="Shipped with Battery"
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Col>
            <Form.Check
              type="switch"
              name="eprom"
              id="switch 2"
              onChange={handleOnChange}
              label="Shipped with Eprom"
            />
          </Col>
        </Form.Group>
        <Form.Group>
          <Form.Label>Description</Form.Label>
          <Form.Control 
            id="desc"
            as="textarea"
            name="description"
            rows="5"
            value={frmData.description}
            onChange={handleOnChange}
          />
        </Form.Group>
        <Button type="submit" variant="dark" block>
          Open Ticket
        </Button>
      </Form>
    </Jumbotron>
  );
};

// AddTicketForm.propTypes = {
//   handleOnSubmit: PropTypes.func.isRequired,
//   handleOnChange: PropTypes.func.isRequired,
//   frmDt: PropTypes.object.isRequired,
//   frmDataErro: PropTypes.object.isRequired,
// };
